<template>
  <div id="app" @click.stop="btnas">
    <router-view />
    <comUpload></comUpload>
  </div>
</template>

<script>
import comUpload from "@/components/common/AllUpload.vue";
import {
  setToken,
  getToken,
  removeToken,
  getUrl,
  setUrl,
  removeUrl,
  setphonenum,
  getphonenum
} from "@/common/cook";
export default {
  name: "App",
  components: {
    comUpload
  },
  data() {
    return {
      websock: null
    };
  },
  methods: {
    btnas() {
      this.$store.commit("setting/setSetdata", {
        key: "showflag",
        data: false
      });
      this.$store.commit("setting/setSetdata", {
        key: "moreflag",
        data: false
      });
      this.$store.commit("setting/setSetdata", {
        key: "zujuanshowflag",
        data: false
      });
    }
  },
  created() {
    // this.initWebSocket();
    // 18535196398
    // setToken('pc3367296a5b2ec29cddb4c4ab16f38add298dd399549aa');
    // setphonenum(15234255053)
    // this.initWebSocket();
    //  18535196398
    // setToken('pc256950f3d982b3caf74d6aa02f6c0cbd26419c1cbc10c')
    // setToken('pc1438ffa2571233aef0c48d616723fc0fef9ebc02fd41')
    // setphonenum(15234255053 )
    // setphonenum(18535196398)
    // setphonenum(18500209493)
    // setphonenum(13233637550)
    // setphonenum(18435117072)
    // setphonenum(18335124655); //杨
    let that = this;
    let Token = getToken();
    let str = window.location.href;
    let num = str.indexOf("#/");
    let href = str.substring(0, num + 2);
    let url = href + "login/login";
    if (Token == undefined || Token == null) {
      this.$router.replace("/login/login");
    } else if (getphonenum() != null && str.length == num + 2) {
      console.log("更新用户信息");
      this.$store.dispatch("user/getuserinfo", {
        tel: getphonenum(),
        type: "modular"
      });
    } else if (str.length == num + 2) {
      window.location.replace(url);
    } else {
      window.localStorage.removeItem("oldxiaoben");
      console.log("更新用户信息");
      this.$store.dispatch("user/getuserinfo", { tel: getphonenum() });
    }

    // 测试使用
    function fackLogin() {
      console.log("测试");
      localStorage.setItem(
        "xueduanlist",
        `[{"id":1,"xueduan_name":"小学","is_del":0,"addtime":0,"uptime":0,"children":[],"lid":1,"title":"小学","mid":1},{"id":2,"xueduan_name":"初中","is_del":0,"addtime":0,"uptime":0,"children":[],"lid":2,"title":"初中","mid":2},{"id":3,"xueduan_name":"高中","is_del":0,"addtime":0,"uptime":0,"children":[],"lid":3,"title":"高中","mid":3}]`
      );
      localStorage.setItem("unionid", "''");
      localStorage.setItem("infoid", "1,1,1,1");
      localStorage.setItem("nowPar", "487");
      localStorage.setItem("nickname", "安彦吏");
      localStorage.setItem("infoname", "小学,语文,人民教育出版社,一年级上册");
      localStorage.setItem("schoolid", "1100108001");
      localStorage.setItem("username", "15135137579");
      localStorage.setItem("schoolname", "太原市外国语学校");
      localStorage.setItem("adminrolename", "普通用户");
      localStorage.setItem("checked", "true");
      localStorage.setItem("userid", "14881");
      localStorage.setItem("pwd", "ayl15135137579");
      localStorage.setItem("tel", "15135137579");
      localStorage.setItem("schoolid", "1100108001");
      localStorage.setItem(
        "logo",
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/header/LOGO.png"
      );
      localStorage.setItem(
        "plat",
        `[{"area_id":0,"city_id":0,"id":0,"level":0,"province_id":0,"title":"个人资源"},{"id":46,"title":"校本资源","area_id":140108,"city_id":"01","province_id":14,"level":4,"logo":"","user_shenhe":0,"isadmin":0},{"id":2,"title":"市级资源","area_id":0,"city_id":"01","province_id":14,"level":2,"logo":"","user_shenhe":0,"isadmin":0},{"area_id":0,"city_id":0,"id":99,"level":99,"province_id":0,"title":"卓育资源库"}]`
      );
      localStorage.setItem(
        "rules",
        `[4,15,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,17,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57]`
      );
      localStorage.setItem("adminroleid", "10");
      localStorage.setItem(
        "face",
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/common/56f340264da8e6d274df8eab3e31a70.jpg"
      );
    }
    // fackLogin();
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

ul,
li {
  list-style: none;
}

body,
div,
ul,
li,
ol,
input,
button,
textarea,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

table {
  border-color: #ddd;
}

svg {
  text-align: left;
}

img,
button {
  outline: none;
  border: none;
  user-select: none;
  border-image-width: 0;
  background: transparent;
  vertical-align: middle;
  appearance: none;
}

input,
textarea {
  outline: none;
  border: none;
}

textarea {
  padding: 12px;
  box-sizing: border-box;
}

a {
  text-decoration: none;
  color: inherit;
}

.clearfix::after {
  clear: both;
  height: 0;
  display: block;
  content: "";
}

body {
  height: 0;
}

#app {
  min-width: 1440px;
  /* height:100vh; */
  height: 100%;
  margin: 0 auto;
  background: #f4f8ff;
  box-sizing: border-box;
}

.mflex {
  display: flex;
  align-items: center;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.ywarp {
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
}

.one-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.fixed {
  position: fixed;
  bottom: 64px;
  right: 64px;
  z-index: 90;
}

.orange {
  color: #f6ac2d;
}

.modal-body {
  width: 590px;
  height: 566px;
  padding: 48px;
  box-sizing: border-box;
  border-radius: 5px;
}

.close-img1 {
  top: 0px;
  right: 12px;
  font-size: 36px;
  color: #333;
  background: #fff;
  font-family: Arial;
}

.suggest {
  width: 100%;
  height: 386px;
  padding: 24px;
  font-size: 14px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #efefef;
}

.what {
  border-radius: 50%;
  background: #61acfe;
  width: 48px;
  line-height: 48px;
  color: #fff;
  font-size: 32px;
  font-family: Helvetica;
  bottom: 36px;
}

img {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.el-dialog {
  border-radius: 6px;
}

.el-avatar > img {
  width: 100%;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

/* 列表 */
.tablelist {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #424242;
}

.tablelists {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
}

#app .el-pagination {
  text-align: center;
}

#app .el-dialog__header {
  border-bottom: 1px solid #ececec;
}

#app .el-pagination .el-pager li {
  width: 38px;
  height: 38px;
  line-height: 38px;
  margin: 0;
  padding: 0;
  margin-right: 12px;
}

#app .el-pager li.active {
  color: #ffffff;
  background: #6ca1ff;
  cursor: pointer;
}

#app .el-pager li:hover {
  color: #ffffff;
  background: #6ca1ff;
}

#app .el-pagination .btn-prev,
#app .el-pagination .btn-next {
  width: 38px;
  height: 38px;
  line-height: 38px;
  margin: 0;
  padding: 0;
  margin-right: 12px;
}

#app .el-pagination button:hover {
  color: #ffffff;
  background: #6ca1ff;
}

#app .el-pagination button {
  height: 38px;
  line-height: 38px;
}

#app .el-pagination span:not([class*="suffix"]) {
  height: 38px;
  line-height: 38px;
}

#app .el-table .cell {
  line-height: initial;
  width: 100%;
}

/* tree树状选中 */
#app .is-current > .el-tree-node__content {
  color: #61acfe;
}

#app .is-current > .el-tree-node__content > .expanded {
  color: #61acfe;
}

#app .el-message-box__btns button:nth-child(2) {
  color: #6ca1ff;
}

#app .el-dialog__body {
  padding: 10px 20px;
}

#app .bumenset .el-tabs__item {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue